import React from 'react'
import { Collapse } from 'antd-mobile-v5'

import styles from './CardLayout.module.scss'

const CardLayout = ({ title, status, children }) => (
  <Collapse accordion defaultActiveKey="0">
    <Collapse.Panel
      title={
        <div className={styles.title}>
          <span>{title}</span>
          {status !== 'none' && (
            <img
              src={require(`../../assets/images/common/${status ? 'complete' : 'warning'}.png`)}
              className={styles['title-icon']}
              alt={''}
            />
          )}
        </div>
      }
      key={'0'}
    >
      {children}
    </Collapse.Panel>
  </Collapse>
)

export default CardLayout
